import { render, staticRenderFns } from "./render-item.vue?vue&type=template&id=6d81c62a"
import script from "./render-item.vue?vue&type=script&lang=js"
export * from "./render-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports